export const FLAG_GETTING_DISCOUNT_CODES = 'FLAG_GETTING_DISCOUNT_CODES';
export const GET_DISCOUNT_CODES = 'GET_DISCOUNT_CODES';
export const CLEAR_DISCOUNT_CODES = 'CLEAR_DISCOUNT_CODES';
export const GET_DISCOUNT_CODE = 'GET_DISCOUNT_CODE';
export const CLEAR_DISCOUNT_CODE = 'CLEAR_DISCOUNT_CODE';
export const FLAG_DISCOUNT_CODE_ACTIVITY = 'FLAG_DISCOUNT_CODE_ACTIVITY';
